// Fragment "save validation" — the admin-namespace messages the validated write paths
// need on top of the generic `common` vocabulary (i18n/dictionaries/common/validation.js).
//
// Only what is genuinely NOT generic lives here:
//   · catalogue.validation.* — a MONEY rule that is specific to a priced catalogue line
//     (product / programme). "Required field" would not say why 0.00 is refused.
//     `affiliateUrlRequired` is that same rule's twin for an affiliate product: its
//     money lives entirely on `affiliate_url` (server.py's `_affiliate_url_when_affiliate`),
//     so an empty or malformed link is refused the same way an unpriced stripe row is.
//   · toast.deleteFailed — the delete twin of common's `errors.saveFailed`. One key, not
//     one per screen: a failed delete reads the same on every list, and a per-screen
//     variant only lets the wording drift.
//   · toast.reloadFailed — ProductsAdmin/ProgramsAdmin's save() and remove() reload the
//     list AFTER a write that already succeeded; a failed reload is not a failed write,
//     and mislabeling it `errors.saveFailed`/`toast.deleteFailed` invites a retry that
//     duplicates the row the first write already created. Worded to fit after either a
//     save or a delete, since both share this one reload step.
//
// `{max}` is interpolated by the caller (the ceiling is a code constant mirroring
// server.py CATALOGUE_PRICE_MAX_CENTS, so it must not be duplicated into three locales).
export default {
  fr: {
    "catalogue.validation.pricePositive": "Indiquez un prix supérieur à 0",
    "catalogue.validation.priceMax": "Le prix ne peut pas dépasser {max}",
    "catalogue.validation.affiliateUrlRequired": "Indiquez un lien complet (https://…) vers le produit",
    "toast.deleteFailed": "Échec de la suppression",
    "toast.reloadFailed": "La liste n'a pas pu être actualisée — actualisez la page pour voir les derniers changements",
  },
  en: {
    "catalogue.validation.pricePositive": "Enter a price greater than 0",
    "catalogue.validation.priceMax": "The price cannot exceed {max}",
    "catalogue.validation.affiliateUrlRequired": "Enter a full link (https://…) to the product",
    "toast.deleteFailed": "Delete failed",
    "toast.reloadFailed": "The list could not be refreshed — reload the page to see the latest changes",
  },
  es: {
    "catalogue.validation.pricePositive": "Introduzca un precio superior a 0",
    "catalogue.validation.priceMax": "El precio no puede superar {max}",
    "catalogue.validation.affiliateUrlRequired": "Indique un enlace completo (https://…) al producto",
    "toast.deleteFailed": "No se pudo eliminar",
    "toast.reloadFailed": "No se pudo actualizar la lista — recargue la página para ver los últimos cambios",
  },
};
